import * as React from "react"
import { cn } from "../utils/cn"

export interface EmojiProps extends React.HTMLAttributes<HTMLSpanElement> {
    /** Font-size multiplier relative to the surrounding text. Defaults to 1.2. */
    scale?: number
}

/**
 * A plain <span> that renders an emoji a touch larger than the surrounding
 * text — inline emojis tend to look small next to body copy. Reusable anywhere:
 *   <Emoji>🎨</Emoji>   or   <Emoji scale={1.5}>🐢</Emoji>
 */
function Emoji({ scale = 1.2, className, style, children, ...props }: EmojiProps) {
    return (
        <span
            className={cn("inline-block leading-none align-middle", className)}
            style={{ fontSize: `${scale}em`, ...style }}
            {...props}
        >
            {children}
        </span>
    )
}

export { Emoji }
